import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, EMPTY, of, share, switchMap } from 'rxjs';
import { UserSettingsService } from '../../services/user-settings.service';
import { UserSettingsModels } from '@share-models';
import { TranslationService } from '../../services/translation.service';
import { UserSettingsActions } from '../state/user-settings/user-settings.actions';
import { SharedActions } from '../state/shared/shared.actions';
import { TranslateService } from '@ngx-translate/core';

export const getMe = createEffect(
  (
    actions$ = inject(Actions),
    userSettingsService = inject(UserSettingsService),
    translateService = inject(TranslateService),
  ) =>
    actions$.pipe(
      ofType(UserSettingsActions.getMe),
      switchMap(({ language }) =>
        userSettingsService.me(language).pipe(
          switchMap((res) => {
            if (!res) {
              return EMPTY;
            }
            return [
              UserSettingsActions.setUserSettings({ userSettings: res }),
              UserSettingsActions.setInterfaceLanguage({ lang: res.lang }),
            ];
          }),
          catchError(() =>
            of(
              SharedActions.showMessage({
                error: translateService.instant(
                  'TOASTS.USER_SETTINGS_LOAD_FAILED',
                ) as string,
              }),
            ),
          ),
        ),
      ),
      share(),
    ),
  { functional: true },
);

export const setInterfaceLanguage = createEffect(
  (
    actions$ = inject(Actions),
    translationService = inject(TranslationService),
  ) =>
    actions$.pipe(
      ofType(UserSettingsActions.setInterfaceLanguage),
      switchMap(({ lang }) => {
        const interfaceLanguage = lang ?? UserSettingsModels.DEFAULT_LANGUAGE;
        translationService.setLanguage(interfaceLanguage);
        return [EMPTY];
      }),
      share(),
    ),
  { functional: true, dispatch: false },
);
